export const dashboard = {
  title: 'Dashboard',
  statisticsTitle: 'Statistics',
  navigationTitle: 'Quick navigation',
  navigationDescription: 'Go directly to any system section',
  noSections: 'No sections available',
  tilesError: 'Unable to load navigation tiles',
  sectionsError: 'Unable to load statistics data',
  sections: {
    dashboardDesc: 'Main view with navigation and key data',
    statisticsDesc: 'Charts and activity statistics from the last 30 days',
    profileDesc: 'Manage your user profile',
  },
  mostPopularProducts: 'Most popular products in last 30 days',
  mostPopularBrands: 'Most popular brands in last 30 days',
  mostPopularModels: 'Most popular models in last 30 days',
  mostPopularColors: 'Most popular colors in last 30 days',
} as const
